import { axios, Response } from '../index'

const deleteClinicChecklist = (clinicChecklistId: string): Response<void> => {
  return axios.delete(`/v1/favorites/favorite-checklists/${clinicChecklistId}`)
}

export default deleteClinicChecklist
